<template>
    <div>
        <div class="h-screen flex overflow-hidden bg-gray-100">
            <!-- Off-canvas menu for mobile -->
            <div class="md:hidden">
                <MobileSidebar ref="mobileSidebar">
                    <!-- Opened sidebar content -->
                    <template v-slot:items> </template>
                </MobileSidebar>
            </div>

            <!-- Static sidebar for desktop -->
            <div class="hidden md:flex md:shrink-0 no-print">
                <div class="flex flex-col w-64">
                    <!-- Sidebar component, swap this element with another sidebar if you like -->
                    <div class="flex flex-col h-0 flex-1">
                        <div class="flex items-center h-16 shrink-0 px-4 bg-gray-900">
                            <a href="/">
                                <img class="h-10 w-auto" src="/svg/logo.svg" alt="Tichit logo" />
                            </a>
                        </div>
                        <div class="flex-1 flex flex-col overflow-y-auto">
                            <nav class="flex-1 px-2 py-4 bg-gray-800"></nav>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col w-0 flex-1 overflow-hidden">
                <!--              <header-nav  @open-mobile-sidebar="$refs.mobileSidebar.open = true"></header-nav>-->
                <FlashMessages />
                <main class="flex-1 relative z-0 overflow-y-auto focus:outline-none" tabindex="0" scroll-region>
                    <slot></slot>
                </main>
            </div>
        </div>
        <div id="modals"></div>
        <div id="slide-overs"></div>
    </div>
</template>

<script>
import FlashMessages from '@/Shared/FlashMessages.vue';
import MobileSidebar from '../components/MobileSidebar.vue';

export default {
    components: {
        MobileSidebar,
        FlashMessages,
    },
};
</script>
